// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ry-z","tooltipWrapper":"Sy-z","icon":"Ty-z","tooltip":"Uy-z","content":"Vy-z"};